import React, {Fragment, useEffect, useState} from 'react';
import {t} from 'i18next';
import AgyleButton from '../../../components/ui/buttons/agyleButton';
import moment from 'moment/moment';
import Formatter from '../../../util/formatter';
import {user} from '../../../store/reducers/user';
import {Checkbox, FormControl, FormControlLabel, FormLabel, Grid, Radio, RadioGroup} from '@mui/material';
import AgyleTextField from '../../../components/ui/fields/agyleTextField';
import AgyleDatePicker from '../../../components/ui/fields/agyleDatePicker';
import _ from 'lodash';
import uuidv4 from 'uuid/v4';
import Notes from '../../../util/notes';
import Divider from '@mui/material/Divider';
import makeStyles from '@mui/styles/makeStyles';
import AgyleAccordion from '../../../components/ui/accordion/agyleAccordion';
import {setSnackbar} from '../../../store/reducers/globals';
import APIForm from '../../../app/apiForm';
import {useDispatch, useSelector} from 'react-redux';
import {CUSTOM_INTERVAL_OPTIONS} from '../../../components/calendar/calendarComponent/bedasSessionsManager';
import AgyleSelectField from '../../../components/ui/selector/agyleSelectField';
import InformationBox from '../../../components/other/informationBox';
import {DATAMatrix} from '../../../util/dataMatrixBarcodeGenerator';
import config from '../../../app/config';
import {addNoteForPatient} from '../../../store/reducers/notes';
import {mapHospitalList} from '../../../store/reducers/ward';
import {ctxEMedLoad} from '../../../store/reducers/patientContext';
import useDict from '../../../hooks/useDict';

const useStyles = makeStyles((theme) => ({

    divider: {
        width: '100%',
        // alignItems: 'center',
        margin: "5px",
    },

    blockSwitch: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    },

    textField: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    },

    provideDetailsLabel: {
        alignItems: 'center',
    },

    radio: {
        width: '100%',
        minWidth: '100%',
    },

    alignRight: {
        textAlign: 'right',
    },

    textIndent: {
        textIndent: "20px",
    },

    mandatory: {
        fontWeight: 'bold',
        color: '#e06666',
    },

}));

const FitnessForWorkForm = (props) => {
    const classes = useStyles();
    const dispatch = useDispatch();

    // Props
    const {extended, selectedHistoryForm: selectedForm} = props;

    // User
    const userObject = useSelector(user);
    const userFullName = Formatter.formatUserFullName(userObject);

    // Selectors
    const loadDialog = useSelector(ctxEMedLoad);
    const maps = useSelector(mapHospitalList);

    const [hospitals] = useDict('hospitals');

    const initFitnessForWork = {
        patientsName: (props.patient.patient.title ? props.patient.patient.title + " " : "") + (props.patient.patient.firstName ? props.patient.patient.firstName: "") + " " + (props.patient.patient.familyName ? props.patient.patient.familyName: ""),
        patientsEmail: props.patient.patient.emailAddress ? props.patient.patient.emailAddress : "",
        assessedCase: moment(),
        assessedCaseDetails: "",
        advise: "",

        benefits: {
            phasedReturn: null,
            alteredHours: null,
            amendedDuties: null,
            workplaceAdaptations: null,
        },
        benefitsDetails: "",

        caseForNumber: null,
        caseForInterval: "",
        caseFrom: null,
        caseTo: null,
        uniqueId: "",
        niNumber: "",

        issuersName: userFullName,
        issuersProfession: "",
        dateOfStatement: moment(),
        issuersAddress: "",

        surname: props.patient?.patient?.familyName ? props.patient?.patient?.familyName : "",
        otherNames: (props.patient.patient.firstName ? props.patient.patient.firstName: "") + " " + (props.patient.patient.middleNames ? props.patient.patient.middleNames: ""),
        address: props.patient?.patient?.addressLines ? props.patient?.patient?.addressLines.join(" ") : "",
        postalCode: props.patient.patient.postalCode ? props.patient.patient.postalCode: "",
        dateOfBirth: props.patient.patient.dob ? moment(props.patient.patient.dob): ""
    }

    const [fitnessForWork, setFitnessForWork] = useState(initFitnessForWork);
    const [customIntervalOptions, setCustomIntervalOptions] = useState(CUSTOM_INTERVAL_OPTIONS);
    const [accordionExpandedState, setAccordionExpandedState] = useState({
        eMed: true,
        gpDemographics: false,
        patientDemographics: false,
        informationBox: false,
    })

    const [gp, setGp] = React.useState(null);
    const [latestEventState, setLatestEventState] = React.useState(false);

    useEffect(() => {
        let data = _.cloneDeep(initFitnessForWork);

        if(window.auth.tokenParsed.jobTitle) {
            data.issuersProfession = window.auth.tokenParsed.jobTitle;
        }

        if (!_.isNil(selectedForm)) {
            data = {...selectedForm};
        }
        setFitnessForWork(data);
        // setLoaded(true);
    }, []);

    useEffect(() => {
        if(!loadDialog) {
            const uniqueId = uuidv4();

            setFitnessForWork(pr => ({
                ...pr,
                uniqueId: uniqueId
            }))
        }
    }, [loadDialog]);

    useEffect(() => {
        if (fitnessForWork.caseForNumber && fitnessForWork.caseForInterval && fitnessForWork.caseFrom){
            let endDate =  moment(fitnessForWork.caseFrom).add({[fitnessForWork.caseForInterval]:fitnessForWork.caseForNumber});

            setFitnessForWork(pr => ({
                ...pr,
                caseTo: endDate
            }))
        }
    }, [fitnessForWork.caseForNumber, fitnessForWork.caseForInterval, fitnessForWork.caseFrom]);

    useEffect(() => {
        if (extended){
            const event = moment(selectedForm.caseTo)
            setFitnessForWork(pr => ({
                ...pr,
                caseForNumber: null,
                caseForInterval: null,
                caseTo: null,
                caseFrom: event
            }))
        } else {
            let latestEvent = moment();
            let loopCounter = 0;
            if (props.patient?.studies?.fitnessForWork?.list) {
                _.forEach(props.patient?.studies?.fitnessForWork?.list, element => {

                    if (!element.canceled) {
                        if (moment(element.caseTo).isAfter(latestEvent)) {
                            latestEvent = moment(element.caseTo);
                        }
                    }else{
                        loopCounter++;
                    }
                });

                if(((props.patient?.studies?.fitnessForWork?.list).length) === loopCounter){
                    latestEvent = moment();
                }else{
                    latestEvent = latestEvent.add(1, 'day');
                }

                setFitnessForWork(prevState => ({
                    ...prevState,
                    caseFrom: latestEvent
                }));

                setLatestEventState(true);
            }
        }
    }, [props.patient?.studies?.fitnessForWork?.list, extended]);

    useEffect(() => {
        const facility = props.patient?.admission?.facility;
        if (facility && hospitals) {
            const findHospital = hospitals.find(hospital => hospital.__id === facility);
            if (findHospital) {
                let hospitalAddress = findHospital?.addresses[0]?.addressLines ? maps[0]?.addresses[0]?.addressLines.join(' ') : null;
                setFitnessForWork(prevState => ({
                    ...prevState,
                    issuersAddress: hospitalAddress,
                }));
            }
        }
    }, [props.patient, hospitals]);

    useEffect(() => {
        if (props.onCustomButtons && loadDialog) {
            props.onCustomButtons([
                <AgyleButton
                    disabled={selectedForm?.canceled}
                    onClick={handleGetPdf}
                    key='getPdf'
                    variant="contained"
                >
                    {t("Preview")}
                </AgyleButton>,
                <AgyleButton
                    disabled={selectedForm?.canceled}
                    onClick={() => handleGeneratePdf()}
                    key='generatePdf'
                    variant="contained"
                >
                    {t("Re-issue duplicate")}
                </AgyleButton>
            ]);
        }
        if (props.onSubmitFunction) {
            props.onSubmitFunction(submit);
        }
        if (props.onDisableSubmit) {
            props.onDisableSubmit(isSubmitDisabled());
        }
    }, [fitnessForWork, props.patient, userObject]);

    const handleGetDuplicateNote = () => {
        dispatch(addNoteForPatient(props.patient.patient.__id, {
            note: Notes.getFitnessForWorkNoteDuplicate(fitnessForWork),
            noteType: "studies.fitnessForWork",
            patientsInWardsRef: [props.patient.__id],
            episodeId: props.patient?.admission?.consultantEpisodeId || null,
        },props.patient.__id));
    };

    const handleGetPdf = () => {
        const clone = _.cloneDeep(props.patient);
        const piwForPDF = props.patient;
        const patientObject = props.patient.patient;

        APIForm.previewDor(
                {data: {
                        fitnessForWork: fitnessForWork,
                        patient: patientObject,
                        name: `${patientObject.familyName} ${patientObject.firstName}`,
                        nhs: patientObject.nhsNumber,
                        landscape: true
                    }}, patientObject.hospitalNumber, "fitnessForWorkPreview")
            .then((res) => {
                    const blob = new Blob([res], {type: "application/pdf"});
                    let objectURL = window.URL.createObjectURL(blob);
                    window.open(objectURL, "_blank");

                    dispatch(setSnackbar({type: "success", message: "DoR genereted"}));
                    return !!res;
                },
                (er)=> {
                    return false
                }
            );
    };

    const handleGeneratePdf = (formName = "fitnessForWorkDuplicate") => {
        handleGetDuplicateNote();
        const clone = _.cloneDeep(props.patient);

        const piwForPDF = props.patient;
        const patientObject = props.patient.patient;

        getImageBarcode(generateBarcodeDataText(fitnessForWork, patientObject, true)).then(imageBarcode => {
            console.log("imageBarcode previewDor duplicate", imageBarcode);
            APIForm.previewDor(
                    {data: {
                            fitnessForWork: {...fitnessForWork, barcode2D: imageBarcode},
                            patient: patientObject,
                            name: `${patientObject.familyName} ${patientObject.firstName}`,
                            nhs: patientObject.nhsNumber,
                            barcode2D: imageBarcode,
                            landscape: true
                        }}, patientObject.hospitalNumber, formName)
                .then((res) => {
                        const blob = new Blob([res], {type: "application/pdf"});
                        let objectURL = window.URL.createObjectURL(blob);
                        window.open(objectURL, "_blank");

                        dispatch(setSnackbar({type: "success", message: "DoR generated"}));
                        return !!res;
                    },
                    (er)=> {
                        return false
                    }
                );
        })
    }

    const isSubmitDisabled = () => {
        const benefitsVal = Object.values(fitnessForWork.benefits);
        const benefitsDetailsVal = fitnessForWork.benefitsDetails;

        let submitDisabled = false;

        if (!fitnessForWork.caseForNumber || !fitnessForWork.caseForInterval || !fitnessForWork.assessedCaseDetails) {
            submitDisabled = true;
        }
        if (!fitnessForWork.advise) {
            submitDisabled = true;
        }
        if (fitnessForWork.advise === "maybeFit" && (benefitsVal.every(value => !value) && !benefitsDetailsVal)) {
            submitDisabled = true;
        }

        return submitDisabled
    }

    const submit = () => {
        const id = uuidv4() + '';
        let data = _.cloneDeep(fitnessForWork);
        const dateOfForm = moment().toISOString();
        const patientObject = props.patient.patient;

        getImageBarcode(generateBarcodeDataText(fitnessForWork, patientObject)).then(imageBarcode => {
            const dataToSave = [{
                name: "studies.fitnessForWork",
                value: {
                    ...data,
                    id: id,
                    date: dateOfForm,
                    by: userFullName,
                    login: userObject?.userName,
                    parentForm: props.parentForm,
                    ageAtComplete: props.age,
                    barcode2D: imageBarcode
                },
                noteToAddWithRefId: prepareNote(),
                idToTrack: id,
                referenceId: id,
            }];

            APIForm.saveDor(
                {data: {
                        fitnessForWork: {...fitnessForWork, barcode2D: imageBarcode},
                        patient: patientObject,
                        name: `${patientObject.familyName} ${patientObject.firstName}`,
                        nhs: patientObject.nhsNumber,
                        landscape: true
                    }} , patientObject.hospitalNumber, "fitnessForWorkEmed3")
                .then((response)=>{
                        handleGeneratePdf("fitnessForWorkEmed3")
                        dispatch(setSnackbar({type: "success", message: "DoR generated"}));
                        return !!response;
                    },
                    (er)=> {
                        return false
                    }
                );

            props.onChange(dataToSave)
        })
    };

    const prepareNote = () => {
        return Notes.getFitnessForWorkNote(fitnessForWork);
    };

    const handleChangeTextField = (event) => {
        const {name, value} = event.target;

        setFitnessForWork(pr => ({
            ...pr,
            [name]:value
        }))
    };
    const handleChangeNumberField = (event) => {
        const {name, value} = event.target;

        let valueTmp = /^[1-9]\d*$/.test(value) ? value : "";

        setFitnessForWork(pr => ({
            ...pr,
            [name]: valueTmp
        }))
    };

    const handleChangeCheckbox = (event, objectKey) => {
        const {name, checked} = event.target;
        setFitnessForWork((pr) =>
            ({
                ...pr,
                [objectKey]: {
                    ...pr[objectKey],
                    [name]:checked
                }
            }));
    };

    const handleChangeRadio = (event) => {
        const {name, value} = event.target;
        setFitnessForWork(pr => ({
            ...pr,
            [name]:value
        }))
    };

    const handleChangeAccordion = (param) => {
        setAccordionExpandedState((pr) =>
            ({
                ...pr,
                [param]:!pr[param]
            }));
    };

    const handleChangeCustomIntervalType = (key, value) => {
        setFitnessForWork(prevState => ({
            ...prevState,
            [key]: value
        }))
    }

    const isAnyFieldFilled = fitnessForWork?.benefitsDetails ||
        fitnessForWork?.benefits?.amendedDuties ||
        fitnessForWork?.benefits?.workplaceAdaptations ||
        fitnessForWork?.benefits?.alteredHours ||
        fitnessForWork?.benefits?.phasedReturn;

    const getImageBarcode = (data, imageTypeStr="image/png") => {
        return new Promise(resolve => {
            try {
                const svg = DATAMatrix(data);
                const width = svg.getAttribute("width");
                const height = svg.getAttribute("height");
                const canvas = document.createElement("canvas");
                const img = document.createElement("img");
                const ctx = canvas.getContext('2d');
                const URL = window.URL || window.webkitURL || window;
                canvas.width = width;
                canvas.height = height;
                const itemData = new XMLSerializer().serializeToString(svg);
                const blob = new Blob([itemData], {
                    type: 'image/svg+xml'
                });
                const url = URL.createObjectURL(blob);
                img.onload = () => {
                    ctx.drawImage(img, 0, 0);
                    URL.revokeObjectURL(url);
                    const ret = canvas.toDataURL(imageTypeStr);
                    canvas.remove();
                    img.remove();
                    resolve(ret);
                }
                img.src = url;
            } catch(ex) {
                console.error(ex);
                resolve(null);
            }
        })
    }

    const generateBarcodeDataText = (formData, patientObj, isDuplicate) => {
        let barcode2dDataElements = "";
        try {
            //2D barcode data elements
            //1 <AssessmentDate>                  maxChar 8
            barcode2dDataElements += (formData.assessedCase ? moment(formData.assessedCase).format("DD-MM-YY") : "") + "|";
            //2 <StatementDate><StatementTime>    maxChar 8
            barcode2dDataElements += (formData.dateOfStatement ? moment(formData.dateOfStatement).format("DD-MM-YY") : "") + "|";
            //3 <Patient.title>                   maxChar 3
            barcode2dDataElements += (patientObj.title ? patientObj.title.slice(0, 3) : "") + "|";
            //4 <Patient.first.name>              maxChar 20
            barcode2dDataElements += patientObj.firstName.slice(0, 20) + "|";
            //5 <Patient.second.name>             maxChar 1
            barcode2dDataElements += (patientObj.middleNames ? patientObj.middleNames.slice(0, 1) : "") + "|";
            //6 <Patient.surname>                 maxChar 30
            barcode2dDataElements += patientObj.familyName.slice(0, 30) + "|";
            //7 <Patient.Address1>                maxChar 15
            barcode2dDataElements += (patientObj.addresses ? patientObj.addresses[0].addressLines.join(" ").slice(0, 15) : "") + "|";
            //8 <Patient.Postcode>                maxChar 8
            barcode2dDataElements += (patientObj.addresses ? patientObj.addresses[0].postalCode.slice(0, 8) : "") + "|";
            //9 <Patient.DOB>                     maxChar 8
            barcode2dDataElements += (patientObj.dob ? moment(patientObj.dob).format("DD-MM-YY") : "") + "|";
            //10 <Diag.Printed.Text>              maxChar 42
            barcode2dDataElements += formData.assessedCaseDetails.slice(0, 42) + "|";
            //11 <NFWFlag>                        maxChar 1
            barcode2dDataElements += (formData.advise == "notFit" ? "1" : "0") + "|";
            //12 <MFWFlag>                        maxChar 1
            barcode2dDataElements += (formData.advise == "maybeFit" ? "1" : "0") + "|";
            //13 <MFWPhaseRtn>                    maxChar 1
            barcode2dDataElements += (formData.benefits.phasedReturn ? "1" : "0") + "|";
            //14 <MFWAlteredHrs>                  maxChar 1
            barcode2dDataElements += (formData.benefits.alteredHours ? "1" : "0") + "|";
            //15 <MFWAmendDuties>                 maxChar 1
            barcode2dDataElements += (formData.benefits.amendedDuties ? "1" : "0") + "|";
            //16 <MFWAdaptWorkplace>              maxChar 1
            barcode2dDataElements += (formData.benefits.workplaceAdaptations ? "1" : "0") + "|";
            //17 <ValidPeriodDays>, <ValidPeriodWeeks>, <ValidPeriodMonths> OR “INDEF” (i.e. <ValidPeriodIndefinite>) maxChar 5
            barcode2dDataElements += (formData.caseForInterval ? _.upperCase(formData.caseForInterval).slice(0, 5) : "INDEF") + "|";
            //18 <ValidPeriodStartDate>           maxChar 8
            barcode2dDataElements += (formData.caseFrom ? moment(formData.caseFrom).format("DD-MM-YY") : "") + "|";
            //19 <ValidPeriodEndDate>             maxChar 8
            barcode2dDataElements += (formData.caseTo ? moment(formData.caseTo).format("DD-MM-YY") : "") + "|";
            //20 <FollowUpAssessment>             maxChar 1
            barcode2dDataElements += "|";
            //21 <UniqueID>                       maxChar 20
            barcode2dDataElements += formData.uniqueId.slice(0, 20) + "|";
            //22 <DuplicateShared>                maxChar 1
            barcode2dDataElements += isDuplicate ? "1|" : "0|";
            //23 <Hospital.name>                  maxChar 20 /// what is it? config?
            barcode2dDataElements += (config.modules?.forms?.fitnessForWork?.hospitalName || "").slice(0, 20) +  "|";
            //24 <Site.address>                   maxChar 15 /// what is it? config?
            barcode2dDataElements += (config.modules?.forms?.fitnessForWork?.siteAddress || "").slice(0, 15) +  "|";
            //25 <Site.postcode>                  maxChar 8 /// what is it? config?
            barcode2dDataElements += (config.modules?.forms?.fitnessForWork?.sitePostcode || "").slice(0, 8) +  "|";
            //26 <Hospital.phone.number>          maxChar 12 /// what is it? config?
            barcode2dDataElements += (config.modules?.forms?.fitnessForWork?.hospitalPhoneNumber || "").slice(0, 12);
            console.log("barcode2dDataElements", barcode2dDataElements);
        } catch(ex) {
            console.error("Error while creating data for barcode", ex);
        } finally {
            return barcode2dDataElements;
        }
    }

    return (
        <>
        <AgyleAccordion
            className={classes.gridContainer}
            expanded={accordionExpandedState.eMed}
            onChange={()=>handleChangeAccordion("eMed")}
            label="Fitness for work"
            formBackground
        >
            {selectedForm?.canceled &&
                <InformationBox type={"warning"}>
                    {t("This form has been cancelled")}
                </InformationBox>
            }
            {!fitnessForWork.patientsEmail &&
                <InformationBox type={"error"}>
                    {t("Unable to send e-mail - patient does not have an e-mail address")}
                </InformationBox>
            }

            <Grid container spacing={2} alignItems={"center"}>
                <Grid item xs={4}>
                    <FormLabel>{t("Patient's Name")}</FormLabel>
                </Grid>

                <Grid item xs={8}>
                    <AgyleTextField
                        fullWidth
                        name="patientsName"
                        maxRows={25}
                        disabled
                        onChange={handleChangeTextField}
                        value={fitnessForWork.patientsName}
                        variant="outlined"
                        noBorder={false}
                        withNewBackground
                        debounce
                    />
                </Grid>

                <Grid item xs={4}>
                    <FormLabel>{t("Patient's e-mail")}</FormLabel>
                </Grid>

                <Grid item xs={8}>
                    <AgyleTextField
                        fullWidth
                        name="patientsEmail"
                        maxRows={25}
                        debounce
                        onChange={handleChangeTextField}
                        value={fitnessForWork.patientsEmail}
                        variant="outlined"
                        disabled
                        noBorder={false}
                        withNewBackground
                    />
                </Grid>

                <Grid item xs={4}>
                    <FormLabel>{t("I assessed your case on:")}</FormLabel>
                </Grid>

                <Grid item xs={8}>
                    <AgyleDatePicker
                        value={fitnessForWork.assessedCase}
                        onChange={(param) => {setFitnessForWork((pr) =>
                            ({
                                ...pr,
                                assessedCase: param
                            }))}}
                        type="date"
                        disablePast={false}
                        disabled
                        noBorder={false}
                        withNewBackground
                    />
                </Grid>

                <Grid item xs={4}>
                    <FormLabel className={fitnessForWork.assessedCaseDetails ? classes.label : classes.mandatory}>{t("and because of the following condition(s):")}{!fitnessForWork.assessedCaseDetails && '*'}</FormLabel>
                </Grid>

                <Grid item xs={8}>
                    <AgyleTextField
                        fullWidth
                        name="assessedCaseDetails"
                        maxRows={25}
                        multiline
                        onChange={handleChangeTextField}
                        value={fitnessForWork.assessedCaseDetails}
                        variant="outlined"
                        disabled={extended || loadDialog}
                        noBorder={false}
                        withNewBackground
                        debounce
                    />
                </Grid>

                <Grid item xs={12}>
                    <FormControl>
                        <FormLabel className={fitnessForWork.advise ? classes.label : classes.mandatory}>{t("I advise you that:")}{!fitnessForWork.advise && '*'}</FormLabel>
                        <RadioGroup
                            row
                            name="advise"
                            onChange={handleChangeRadio}
                            value={fitnessForWork.advise}
                        >
                            <FormControlLabel disabled={extended || loadDialog} value="notFit" control={<Radio />} label={t("you are not fit for work")}/>
                            <FormControlLabel disabled={extended || loadDialog} value="maybeFit" control={<Radio />} label={t("you may be fit for work taking account of the following advice")}/>
                        </RadioGroup>
                    </FormControl>
                </Grid>

                <Divider className={classes.divider}/>

                {fitnessForWork.advise === "maybeFit" && (
                    <>
                        <Grid item xs={12}>
                            <FormLabel className={isAnyFieldFilled ? classes.label : classes.mandatory}>
                                {t("If available, and with your employer's agreement, you may benefit from:")}{!isAnyFieldFilled && '*'}
                            </FormLabel>
                        </Grid>
                        <Grid item xs={12}>
                            <FormControlLabel
                                disabled={extended || loadDialog}
                                control={
                                    <Checkbox
                                        onChange={(event)=> handleChangeCheckbox(event, "benefits")}
                                        checked={fitnessForWork.benefits.phasedReturn}
                                        name="phasedReturn"
                                    />
                                }
                                label="a phased return to work"
                            />
                            <FormControlLabel
                                disabled={extended || loadDialog}
                                control={
                                    <Checkbox
                                        onChange={(event)=> handleChangeCheckbox(event, "benefits")}
                                        checked={fitnessForWork.benefits.alteredHours}
                                        name="alteredHours"
                                    />
                                }
                                label="altered hours"
                            />
                            <FormControlLabel
                                disabled={extended || loadDialog}
                                control={
                                    <Checkbox
                                        onChange={(event)=> handleChangeCheckbox(event, "benefits")}
                                        checked={fitnessForWork.benefits.amendedDuties}
                                        name="amendedDuties"
                                    />
                                }
                                label="amended duties"
                            />
                            <FormControlLabel
                                disabled={extended || loadDialog}
                                control={
                                    <Checkbox
                                        onChange={(event)=> handleChangeCheckbox(event, "benefits")}
                                        checked={fitnessForWork.benefits.workplaceAdaptations}
                                        name="workplaceAdaptations"
                                    />
                                }
                                label="workplace adaptation"
                            />
                        </Grid>

                        <Grid item xs={5}>
                            <FormLabel className={isAnyFieldFilled ? classes.label : classes.mandatory}>
                                {t("Comments, including functional effects of your condition(s)")}{!isAnyFieldFilled && '*'}
                            </FormLabel>
                        </Grid>

                        <Grid item xs={7}>
                            <AgyleTextField
                                fullWidth
                                name="benefitsDetails"
                                maxRows={25}
                                multiline
                                onChange={handleChangeTextField}
                                value={fitnessForWork.benefitsDetails}
                                variant="outlined"
                                disabled={extended || loadDialog}
                                noBorder={false}
                                withNewBackground
                                debounce
                            />
                        </Grid>
                        <Divider className={classes.divider}/>
                    </>
                )}

                <Grid item xs={3}>
                    <FormLabel className={fitnessForWork.caseForNumber && fitnessForWork.caseForInterval ? classes.label : classes.mandatory}>{t("This will be the case for")}{!(fitnessForWork.caseForNumber && fitnessForWork.caseForInterval) && '*'}</FormLabel>
                </Grid>

                <Grid item xs={1}>
                    <AgyleTextField
                        fullWidth
                        name="caseForNumber"
                        onChange={handleChangeNumberField}
                        value={fitnessForWork.caseForNumber}
                        variant="outlined"
                        type="number"
                        inputProps={{maxLength: 3}}
                        disabled={loadDialog}
                        noBorder={false}
                        withNewBackground
                        debounce
                    />
                </Grid>

                <Grid item xs={2}>
                    <AgyleSelectField
                        onChange={(value) => handleChangeCustomIntervalType("caseForInterval", value)}
                        value={fitnessForWork.caseForInterval}
                        options={CUSTOM_INTERVAL_OPTIONS}
                        label={t("Select Interval")}
                        withBackground
                        disabled={loadDialog}
                        noBorder={false}
                        withNewBackground
                        debounce
                    />
                </Grid>

                <Grid item xs={6}>
                    <FormLabel>{t("(s)")}</FormLabel>
                </Grid>

                <Grid item xs={3} className={classes.alignRight}>
                    <FormLabel>{t("from")}</FormLabel>
                </Grid>

                <Grid item xs={3}>
                    <AgyleDatePicker
                        value={fitnessForWork.caseFrom}
                        onChange={(param) => {setFitnessForWork((pr) =>
                            ({
                                ...pr,
                                caseFrom: param
                            }))}}
                        type="date"
                        disabled={loadDialog || latestEventState}
                        noBorder={false}
                        withNewBackground
                    />
                </Grid>

                <Grid item xs={3} className={classes.alignRight}>
                    <FormLabel>{t("to")}</FormLabel>
                </Grid>

                <Grid item xs={3}>
                    <AgyleDatePicker
                        value={fitnessForWork.caseTo}
                        type="date"
                        disabled
                        noBorder={false}
                        withNewBackground
                    />
                </Grid>

                <Grid item xs={3}>
                    <FormLabel>{t("NI number")}</FormLabel>
                </Grid>

                <Grid item xs={9}>
                    <AgyleTextField
                        fullWidth
                        name="niNumber"
                        maxRows={25}
                        debounce
                        multiline
                        onChange={handleChangeTextField}
                        value={fitnessForWork.niNumber}
                        variant="outlined"
                        disabled={extended || loadDialog}
                        noBorder={false}
                        withNewBackground
                    />
                </Grid>

                <Grid item xs={3}>
                    <FormLabel>{t("Unique Id")}</FormLabel>
                </Grid>

                <Grid item xs={9}>
                    <AgyleTextField
                        fullWidth
                        name="uniqueId"
                        maxRows={25}
                        debounce
                        value={fitnessForWork.uniqueId}
                        variant="outlined"
                        disabled
                        noBorder={false}
                        withNewBackground
                    />
                </Grid>
            </Grid>
        </AgyleAccordion>

        <AgyleAccordion
            className={classes.gridContainer}
            expanded={accordionExpandedState.gpDemographics}
            onChange={()=>handleChangeAccordion("gpDemographics")}
            label="Issuer demographics"
            formBackground
        >
            <Grid container spacing={2} alignItems={"center"}>

                <Grid item xs={3}>
                    <FormLabel>{t("Issuer's name")}</FormLabel>
                </Grid>
                <Grid item xs={9}>
                    <AgyleTextField
                        fullWidth
                        name="issuersName"
                        maxRows={25}
                        debounce
                        onChange={handleChangeTextField}
                        value={fitnessForWork.issuersName}
                        variant="outlined"
                        disabled
                        noBorder={false}
                        withNewBackground
                    />
                </Grid>

                <Grid item xs={3}>
                    <FormLabel>{t("Issuer's role")}</FormLabel>
                </Grid>
                <Grid item xs={9}>
                    <AgyleTextField
                        fullWidth
                        name="issuersProfession"
                        maxRows={25}
                        debounce
                        onChange={handleChangeTextField}
                        value={fitnessForWork.issuersProfession}
                        variant="outlined"
                        disabled
                        noBorder={false}
                        withNewBackground
                    />
                </Grid>

                <Grid item xs={3}>
                    <FormLabel>{t("Date of statement")}</FormLabel>
                </Grid>
                <Grid item xs={9}>
                    <AgyleDatePicker
                        value={fitnessForWork.dateOfStatement}
                        onChange={(param) => {setFitnessForWork((pr) =>
                            ({
                                ...pr,
                                dateOfStatement: param
                            }))}}
                        type="date"
                        disablePast={false}
                        disabled
                        noBorder={false}
                        withNewBackground
                    />
                </Grid>

                <Grid item xs={3}>
                    <FormLabel>{t("Issuer's address")}</FormLabel>
                </Grid>
                <Grid item xs={9}>
                    <AgyleTextField
                        fullWidth
                        name="issuersAddress"
                        // className={classes.input}
                        maxRows={25}
                        debounce
                        multiline
                        onChange={handleChangeTextField}
                        value={fitnessForWork.issuersAddress}
                        variant="outlined"
                        // error={!fitnessForWork.issuersAddress}
                        disabled
                        noBorder={false}
                        withNewBackground
                    />
                </Grid>
            </Grid>
        </AgyleAccordion>

        <AgyleAccordion
            className={classes.gridContainer}
            expanded={accordionExpandedState.patientDemographics}
            onChange={()=>handleChangeAccordion("patientDemographics")}
            label="Patient demographics"
            formBackground
        >
            <Grid container spacing={2} alignItems={"center"}>

        <Grid item xs={3}>
            <FormLabel>{t('Surname')}</FormLabel>
        </Grid>

        <Grid item xs={9}>
            <AgyleTextField
                fullWidth
                name="surname"
                maxRows={25}
                debounce
                multiline
                onChange={handleChangeTextField}
                value={fitnessForWork.surname}
                variant="outlined"
                disabled
                noBorder={false}
                withNewBackground
            />
        </Grid>

        <Grid item xs={3}>
            <FormLabel>{t('Other names')}</FormLabel>
        </Grid>
            <Grid item xs={9}>
                <AgyleTextField
                    fullWidth
                    name="otherNames"
                    maxRows={25}
                    debounce
                    multiline
                    onChange={handleChangeTextField}
                    value={fitnessForWork.otherNames}
                    variant="outlined"
                    disabled
                    noBorder={false}
                    withNewBackground
                />
                </Grid>

                <Grid item xs={3}>
                    <FormLabel>{t("Address")}</FormLabel>
                </Grid>

                <Grid item xs={7}>
                    <AgyleTextField
                        fullWidth
                        name="address"
                        maxRows={25}
                        debounce
                        multiline
                        onChange={handleChangeTextField}
                        value={fitnessForWork.address}
                        variant="outlined"
                        disabled
                        noBorder={false}
                        withNewBackground
                    />
                </Grid>

                <Grid item xs={2}>
                    <AgyleTextField
                        fullWidth
                        name="postalCode"
                        maxRows={25}
                        debounce
                        multiline
                        onChange={handleChangeTextField}
                        value={fitnessForWork.postalCode}
                        variant="outlined"
                        disabled
                        noBorder={false}
                        withNewBackground
                    />
                </Grid>

                <Grid item xs={3}>
                    <FormLabel>{t("Date of birth")}</FormLabel>
                </Grid>

                <Grid item xs={9}>
                    <AgyleDatePicker
                        value={fitnessForWork.dateOfBirth}
                        onChange={(param) => {setFitnessForWork((pr) =>
                            ({
                                ...pr,
                                dateOfBirth: param
                            }))}}
                        type="date"
                        disablePast={false}
                        disabled
                        noBorder={false}
                        withNewBackground
                    />
                </Grid>
            </Grid>
        </AgyleAccordion>

        <AgyleAccordion
            className={classes.gridContainer}
            expanded={accordionExpandedState.informationBox}
            onChange={()=>handleChangeAccordion("informationBox")}
            label="Information for patient"
            formBackground
        >
            <Grid container spacing={2} alignItems={"center"}>
                <Divider className={classes.divider}/>

                <Grid item xs={12}>
                    <FormLabel><div><h3> {t('What your advice means')} </h3></div></FormLabel>
                    <FormLabel className={classes.textIndent}>
                        <div><b> {t('You are not fit for work')} </b></div>
                        <div> {t('Your health condition means that you may not be able to work for the period shown.' +
                                'You can go back to work as soon as you feel able to and, with your employer\'s agreement, ' +
                                'this may be before your fit note runs out.')}
                        </div>

                        <div><b> {t('You may be fit for work')} </b></div>
                        <div> {t('You could go back to work with the support of your employer. Sometimes your employer ' +
                            'cannot give you the support you need and if this happens your employer will treat this form ' +
                            'as though you are ')}
                            <b>{t('\'not fit for work\'')}</b>{t('. You do not need to get another of these forms.')}
                        </div>

                        <div> {t('For more information please visit')} <b><u>{t('www.gov.uk')}</u></b> {t('and ' +
                            'type')} <b>{t('fit note guidance for patients and employees')}</b> {t('into the search field. Fit note guidance for employers is also available.')}
                        </div>

                        <div> {t('Data form')} <b>{t('page 1')}</b> {t('of this form may be collected to learn about national patterns ' +
                                'of sickness absence. Individuals will not be identified. Find out more ' +
                                'at')} <b><u>{t('www.gov.uk/dwp/fit-note-data')}</u></b></div>

                    </FormLabel>
                </Grid>

                <Divider className={classes.divider}/>

                <Grid item xs={12}>
                    <FormLabel><h3>{t('What do you need to know')}</h3></FormLabel>
                    <FormLabel>
                        <ul>
                            <li>{t("If you are employed:" + "Please show this form to your employer. You could get Statutory Sick Pay (SSP) which is paid by your employer. If your employer cannot pay you SSP they will give you form SSP1 to claim benefits.")}</li>
                            <li> {t("If you are self-employed: You could claim benefits.")} </li>
                            <li> {t(" If you are already claiming benefits: Please send this form to the office dealing with your claim.")} </li>
                            <li> {t("If you need to make a claim to benefits: Visit www.gov.uk/browse/benefits or phone 0800 328 5644 (8am to 6pm Monday to Friday). Textphone users call 0800 328 1344.")} </li>
                        </ul>
                    </FormLabel>
                </Grid>

                <Divider className={classes.divider}/>
            </Grid>
        </AgyleAccordion>
        </>
    )
}

export default FitnessForWorkForm;